@if (item()) {
	<!-- Main container -->
	<div class="item-container">
		<!-- User Avatar -->
		<dc-avatars [userModels]="[item()]" />

		<!-- User Details -->
		<div class="item-content">
			<!-- Added min-w-0 for text truncation -->
			<!-- User Name - Use fullname or username -->
			<div class="font-semibold text-gray-800 truncate">
				{{ item().fullname || item().username || 'שם משתמש לא זמין' }}
			</div>

			<!-- Department/Role (Use 'department' and 'title' from MinimalUserModel) -->
			@if (item().title || item().department) {
				<div class="text-sm text-gray-600 truncate">
					{{ item().title }}
					@if (item().title && item().department) {
						|
					}
					{{ item().department }}
				</div>
			}

			<!-- Email and Status (Use 'email' and 'enabled' from MinimalUserModel) -->
			<div class="text-sm text-gray-500 truncate">
				{{ item().email || 'אין אימייל' }}
				<!-- Use 'enabled' instead of 'isActive' -->
				@if (item().enabled !== undefined && item().enabled !== null) {
					<span class="mx-1">|</span>
					<span [class.text-green-600]="item().enabled" [class.text-red-600]="!item().enabled">
						{{ item().enabled ? 'פעיל' : 'לא פעיל' }}
					</span>
				}
			</div>
		</div>
	</div>
} @else {
	<!-- Optional: Placeholder if item is somehow null/undefined initially -->
	<div class="p-4 border rounded-md animate-pulse bg-gray-100 flex items-center space-x-4">
		<div class="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0"></div>
		<div class="flex-grow space-y-2">
			<div class="h-4 bg-gray-300 rounded w-3/4"></div>
			<div class="h-3 bg-gray-300 rounded w-1/2"></div>
		</div>
	</div>
}
